import { render } from "./ProjectContextModalStretchGoal.vue?vue&type=template&id=7490bb64"
import script from "./ProjectContextModalStretchGoal.vue?vue&type=script&lang=js"
export * from "./ProjectContextModalStretchGoal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__